/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @author Evgeniy Naumov
 * @version 1.26.0
 * @since 1.14.0
 */

import { ChangeEvent, FormEvent } from 'react';

import { Input } from '@components/common';

import FormField, { IFormFieldProps } from './FormField';

interface IFormFieldInputProps {
    min?: number;
    max?: number;
    onChange?: (event: FormEvent<HTMLInputElement> | ChangeEvent<HTMLInputElement>) => void;
}

const FormFieldInput = (props: IFormFieldProps & IFormFieldInputProps) => (
    <FormField {...props}>
        {({ field, kind, disabled, label, labelHint, dataName, required, hintMessage, inputtype }) => {
            return (
                <Input
                    {...field}
                    dataName={dataName}
                    disabled={disabled}
                    hintMessage={hintMessage}
                    inputtype={inputtype}
                    kind={kind}
                    label={label}
                    labelHint={labelHint}
                    max={props.max}
                    min={props.min}
                    placeholder={props.placeholder}
                    required={required}
                    onChange={(data) => {
                        field.onChange(data);
                        if (props.onChange) {
                            props.onChange(data);
                        }
                    }}
                />
            );
        }}
    </FormField>
);

export default FormFieldInput;
